import { render, staticRenderFns } from "./CustomerCPF.vue?vue&type=template&id=453fc46d&"
import script from "./CustomerCPF.vue?vue&type=script&lang=js&"
export * from "./CustomerCPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports